export default "__VITE_ASSET__CwTiAYU2__"